(function () {
    initializeUtilsFunctions();
    executeOnce('lp_optimized', function () {
        if (document.querySelectorAll("#landing-page-optimized").length > 0){
            function isElementInViewport (el) {
                if (typeof jQuery === "function" && el instanceof jQuery) {
                    el = el[0];
                }
                let rect = el.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
                );
            }

            function controlNavbar() {
                const navbar = document.querySelector("#landing-page-optimized .navbar-container");
                if (navbar) {
                    if (!isElementInViewport(document.querySelector("#landing-page-optimized .title-container button"))){
                        navbar.classList.remove("hidden");
                    } else {
                        navbar.classList.add("hidden");
                    }  
                }
            }

            const dropdownlp = document.querySelectorAll("#landing-page-optimized .dropdown");
            dropdownlp.forEach(d => {
                d.querySelector(".dropdown-title").addEventListener("click", () => {
                    if (d) {
                        const arrow = d.querySelector(".dropdown-title .rcs-icon-arrow-down");
                        const body = d.querySelector(".dropdown-body");
                        const line = d.querySelector(".dropdown-title .line");
                        if (arrow && body && line){
                            if (arrow.classList.contains("rotated")){
                                arrow.classList.remove("rotated");
                                line.classList.remove("hidden");
                                body.classList.add("hidden");
                            } else {
                                arrow.classList.add("rotated");
                                line.classList.add("hidden");
                                body.classList.remove("hidden");
                            }
                        }
                    }
                })
            });

            document.addEventListener("scroll", controlNavbar);

            document.querySelectorAll("#landing-page-optimized .toggle-modal-form-lead").forEach(el => {
                el.addEventListener("click", () => {
                    if (!document.getElementsByClassName('banner-cac').length) {
                        document.querySelector("#landing-page-optimized .modal-form-lead").classList.add("visible");
                        document.querySelector("body").style.overflowY = "hidden";
                    }
                })
            })

            document.querySelectorAll("#landing-page-optimized .modal-title .rcs-icon-close").forEach(el => {
                el.addEventListener("click", () => {
                    document.querySelector("#landing-page-optimized .modal-form-lead").classList.remove("visible");
                    document.querySelector("body").style.overflowY = "auto";
                })
            })

            document.querySelector("#landing-page-optimized .social-sharing span").addEventListener("click", () => {
                document.querySelector("#landing-page-optimized .social-sharing #share-content-page").click();
            })

            controlNavbar();
        }
        
    })
})();